<template>
	<div>
		<!-- BEGIN PAGE BAR -->
		<div class="page-bar">
			<breadcrumb :crumbs="breadcrumbArray"></breadcrumb>
		</div>
		<!-- END PAGE BAR -->
		<!-- BEGIN PAGE TITLE-->
	    <h1 class="page-title">What to do next . . .</h1>
	    <!-- END PAGE TITLE-->
		<div>
			<div class="timeline col-sm-6">
				<div class="timeline-item" v-for="toDo in toDos" v-if="activeAccount.account_type === toDo.type">
					<div class="timeline-badge">
						<div class="timeline-icon">
							<i :class="[toDo.color, toDo.icon_class]"></i>
						</div>
					</div>
					<div class="timeline-body">
						<div class="timeline-body-arrow"></div>
						<div class="timeline-body-head">
							<div class="timeline-body-head-caption">
								<span class="timeline-body-alerttitle clickable" :class="toDo.color" @click="startOnboarding(toDo.app, toDo.subApp)">{{ toDo.title }}</span>
							</div>
						</div>
						<div class="timeline-body-content">
							<span class="font-grey-cascade">
								{{ toDo.text }}
							</span>
							<br>
							<button type="button" class="btn blue margin-top-20" @click="startOnboarding(toDo.app, toDo.subApp)">Get Started</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import $ from 'jquery'
import Breadcrumb from '../modules/Breadcrumb'
import { mapGetters } from 'vuex'

/**
 * Dashboard module is the dashboard page.
 * @class Dashboard
 * @since 0.0.2
 */

let navElement

export default {
	data () {
		return {
			breadcrumbArray: [
				{name: 'Dashboard', link: false}
			],
			toDos: [
				{app: 'unoapp_business', subApp: 'users', color: 'font-green-haze', title: 'Add your first UNOapp user', text: 'Learn how to create and manage UNOapp staff users through the UNOapp Business Users App.', icon_class: 'icon-user', type: 'unoapp'},
				{app: 'my_business', subApp: 'users', color: 'font-green-haze', title: 'Add your first business user', text: 'Learn how to create and manage users through the My Business Users App.', icon_class: 'icon-user', type: 'business'},
				{app: 'unoapp_business', subApp: 'roles', color: 'font-blue-sharp', title: 'Create your first UNOapp role', text: 'Learn how to create and manage UNOapp roles where you can group your users to give them specialized privileges through the UNOapp Business Roles App.', icon_class: 'fa fa-sitemap', type: 'unoapp'},
				{app: 'my_business', subApp: 'roles', color: 'font-blue-sharp', title: 'Create your first business role', text: 'Learn how to create and manage roles where you can group your users to give them specialized privileges through the My Business Roles App.', icon_class: 'fa fa-sitemap', type: 'business'},
				{app: 'my_business', subApp: 'locations', color: 'font-purple-studio', title: 'Create your first business location', text: 'Learn how to create and manage locations through the My Business Locations App.', icon_class: 'icon-pointer', type: 'business'},
				{app: 'business_manager', color: 'font-purple-studio', title: 'Create your first Business', text: 'Learn how to create and manage Business\'s through the Business Manager App.', icon_class: 'fa fa-briefcase', type: 'unoapp'}
			]
		}
	},
	computed: mapGetters([
		'activeAccount'
	]),
	methods: {
		/**
		 * To initialize the onboarding indicator and attach the appropriate methods to that element.
		 * @function
		 * @param {string} app - The main app that the indicator is set on (even if there is a sub app it may be included as a part of this app due to the menu already being open).
		 * @param {string} subApp - The sub app that the indicator should display on once the menu gets opened.
		 * @returns {object} - A list of methods to be performed on the element.
		 * @memberof Dashboard
		 * @extends Dashboard
		 * @class initializeOnboardingLink
		 * @version 0.0.4
		 */
		initializeOnboardingLink (app, subApp) {
			let htmlElement = $('.page-sidebar').find('#' + app + '_link')

			return {
				/**
				 * To initialize the onboarding indicator and set up click binding for when that option gets chosen.
				 * @function
				 * @returns {undefined}
				 * @memberof Dashboard.initializeOnboardingLink
				 * @version 0.0.4
				 */
				init () {
					htmlElement.addClass('onboard-link')
					let _this = this

					// Set up element binding
					htmlElement.bind('click', () => {
						_this.cancel()
					})
				},
				/**
				 * To cancel the binding and indicator on the current element and move to the next element if necessary.
				 * @function
				 * @returns {undefined}
				 * @memberof Dashboard.initializeOnboardingLink
				 * @version 0.0.4
				 */
				cancel () {
					this.destroy()

					if (subApp) {
						htmlElement = $('.page-sidebar').find('#' + app + '_' + subApp + '_link')
						this.init()

						subApp = false
					}
				},
				/**
				 * To cancel the binding and indicator without continuing the process.
				 * @function
				 * @returns {undefined}
				 * @memberof Dashboard.initializeOnboardingLink
				 * @version 0.0.4
				 */
				destroy () {
					htmlElement.unbind('click')
					htmlElement.removeClass('onboard-link')
				}
			}
		},
		/**
		 * To start the navigation indicators for the specified onboarding task.
		 * @function
		 * @param {string} app - The app that is going to be highlighted.
		 * @param {string} subApp - The optional sub app that is going to be highlighted.
		 * @returns {undefined}
		 * @memberof Dashboard
		 * @version 0.0.4
		 */
		startOnboarding (app, subApp) {
			if (navElement) {
				navElement.destroy()
			}

			// Need to first check if this menu has a sub nav
			let appLink = $('.page-sidebar').find('#' + app + '_link')

			if (appLink.find('.sub-menu').length) {
				// If there is a sub nav then we need to check if it is open or closed
				if (appLink.hasClass('open')) {
					// If it is open then we can skip the first indicator and start the second.
					navElement = this.initializeOnboardingLink(app + '_' + subApp)

					if (!$('.page-sidebar').find('#' + app + '_' + subApp + '_link').hasClass('onboard-link')) {
						navElement.init()
					}
				} else {
					navElement = this.initializeOnboardingLink(app, subApp)
					if (!$('.page-sidebar').find('#' + app + '_link').hasClass('onboard-link')) {
						navElement.init()
					}
				}
			} else {
				navElement = this.initializeOnboardingLink(app)

				if (!$('.page-sidebar').find('#' + app + '_link').hasClass('onboard-link')) {
					navElement.init()
				}
			}
		}
	},
	components: {
		Breadcrumb
	}
}
</script>
<style>
@keyframes navigationHighlightPulse {
	0%, 100% {
		background-color: transparent;
	} 50% {
		background-color: rgba(55, 183, 217, .3);
		color: #fff;
	}
}
@keyframes navigationHighlightPulseColorOnly {
	0%, 100% {
		color: inherit;
	} 50% {
		color: #fff;
	}
}
.page-sidebar .page-sidebar-menu .onboard-link > a {
	animation: navigationHighlightPulse 1s infinite ease-in-out both;
}
.page-sidebar .page-sidebar-menu .onboard-link > a > i, .page-sidebar .page-sidebar-menu .onboard-link > a > span.arrow:before {
	animation: navigationHighlightPulseColorOnly 1s infinite ease-in-out both;
}
</style>


// WEBPACK FOOTER //
// Dashboard.vue?1a9a1b0c